import $ from 'jquery';
import { Component } from 'react';
import PropTypes from 'prop-types';
import defer from 'lodash/defer';

import autobind from 'class-autobind';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

import { scrollToElement, scrollToTop } from 'zoomforth_codesbane_viewer/lib/scroll_utils.js';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import loglevel from 'loglevel';

class ScrollManagerForViewer extends Component {

  constructor(props) {
    super(props);
    autobind(this);
  }

  componentDidMount() {
    // Scrolls on page load
    this.handleScroll({}, this.props, true); // The tiles arent rendered yet, wait until next call stack
  }

  componentWillReceiveProps(nextProps) {
    this.handleScroll(this.props, nextProps, false); // Immediately scroll
  }

  handleScroll(props, nextProps, deferredInvokation=false) {

    const invoker = deferredInvokation ? 
        defer // Invoke after current call stack
      : 
        (func, ...args)=> func(...args); // Invoke now

    if (
      nextProps.isScrollingToTop && 
      nextProps.isScrollingToTop !== props.isScrollingToTop
    ) {
      invoker(this.handleScrollToTop, nextProps.scrollingAnimationTimeMs);
    }
    if (
      nextProps.scrollingToSectionId && 
      nextProps.scrollingToSectionId !== props.scrollingToSectionId
    ) {
      invoker(this.handleScrollToSection, nextProps.scrollingToSectionId, nextProps.scrollingAnimationTimeMs);
    }
    if (
      nextProps.scrollingToTileUuid && 
      nextProps.scrollingToTileUuid !== props.scrollingToTileUuid
    ) {
      if (nextProps.renderAsMobile) { // We can assume that renderAsMobile will never change!
        invoker(this.handleScrollToTileMobile, nextProps.scrollingToTileUuid, nextProps.scrollingAnimationTimeMs);
      } else {
        invoker(this.handleScrollToTileDesktop, nextProps.scrollingToTileUuid, nextProps.scrollingAnimationTimeMs);
      }
    }
    if (
      nextProps.scrollingToAccordionItemUuid && 
      nextProps.scrollingToAccordionItemUuid !== props.scrollingToAccordionItemUuid
    ) {
      if (nextProps.renderAsMobile) { // We can assume that renderAsMobile will never change!
        invoker(this.handleScrollToAccordionItemMobile, nextProps.scrollingToAccordionItemUuid, nextProps.scrollingAnimationTimeMs);
      } else {
        invoker(this.handleScrollToAccordionItemDesktop, nextProps.scrollingToAccordionItemUuid, nextProps.scrollingAnimationTimeMs);
      }
    }    
  }

  handleScrollToTop(scrollingAnimationTimeMs) {
    scrollToTop($(APP_CONTAINER_SELECTOR), scrollingAnimationTimeMs)
      .done(() => {
        this.props.onScrolledToTop();
      });
  }

  handleScrollToSection(scrollingToSectionId, scrollingAnimationTimeMs) {

    const $scrollBase = $(APP_CONTAINER_SELECTOR);
    const $sectionWrapper = getSectionWrapperElem(scrollingToSectionId);

    // sometimes this may not be available yet and hence we should bail
    if ($sectionWrapper.length === 0) {
      loglevel.error(`Failed to scroll to section ${scrollingToSectionId}; element missing.`);
      return;
    }

    // take into account the navigation as an offset
    var navigationHeight;
    if (this.props.renderAsMobile) {
      navigationHeight = $('.nav-opener-container').outerHeight(true);
    } else {
      navigationHeight = $('.navigation-links').outerHeight(true);
    }

    scrollToElement($scrollBase, $sectionWrapper, navigationHeight, scrollingAnimationTimeMs)
      .done(this.props.onScrollingToSectionIdDone);
  }


  handleScrollToTileDesktop(scrollingToTileUuid, scrollingAnimationTimeMs) {

    const $scrollBase = $(APP_CONTAINER_SELECTOR);
    const $tileWrapper = getTileWrapperElem(scrollingToTileUuid);

    // sometimes this may not be available yet and hence we should bail
    if ($tileWrapper.length === 0) {
      loglevel.info(`Failed to scroll to tile ${scrollingToTileUuid}; element missing.`);
      return;
    }
    // take into account the navigation as an offset
    const navigationHeight = $('.navigation-links').outerHeight(true);

    scrollToElement($scrollBase, $tileWrapper, navigationHeight, scrollingAnimationTimeMs).done(() => {
      getTracker().handleContentScrolledToTile(scrollingToTileUuid);
      this.props.onScrollingToContentItemDone();
    });
  }

  handleScrollToTileMobile(scrollingToTileUuid, scrollingAnimationTimeMs) {

    const $scrollBase = $(APP_CONTAINER_SELECTOR);
    const $tileWrapper = getTileWrapperElem(scrollingToTileUuid);

    // sometimes this may not be available yet and hence we should bail
    if ($tileWrapper.length === 0) {
      loglevel.info(`Failed to scroll to tile ${scrollingToTileUuid}; element missing.`);
      return;
    }

    // take into account the navigation as an offset
    const navigationHeight = $('.nav-opener-container').outerHeight(true);

    scrollToElement($scrollBase, $tileWrapper, navigationHeight, scrollingAnimationTimeMs).done(() => {
      getTracker().handleContentScrolledToTile(scrollingToTileUuid);
      this.props.onScrollingToContentItemDone();
    });
  }

  handleScrollToAccordionItemDesktop(scrollingToAccordionItemUuid, scrollingAnimationTimeMs) {

    const $scrollBase = $(APP_CONTAINER_SELECTOR);
    const $accordionItem = getAccordionItemElem(scrollingToAccordionItemUuid);

    // sometimes this may not be available yet and hence we should bail
    if ($accordionItem.length === 0) {
      loglevel.info(`Failed to scroll to accordion item ${scrollingToAccordionItemUuid}; element missing.`);
      return;
    }
    // take into account the navigation as an offset
    const navigationHeight = $('.navigation-links').outerHeight(true);

    scrollToElement($scrollBase, $accordionItem, navigationHeight, scrollingAnimationTimeMs).done(() => {
      getTracker().handleContentScrolledToTile(scrollingToAccordionItemUuid);
      this.props.onScrollingToContentItemDone();
    });
  }

  handleScrollToAccordionItemMobile(scrollingToAccordionItemUuid, scrollingAnimationTimeMs) {

    const $scrollBase = $(APP_CONTAINER_SELECTOR);
    const $accordionItem = getAccordionItemElem(scrollingToAccordionItemUuid);

    // sometimes this may not be available yet and hence we should bail
    if ($accordionItem.length === 0) {
      loglevel.info(`Failed to scroll to accordion item ${scrollingToAccordionItemUuid}; element missing.`);
      return;
    }

    // take into account the navigation as an offset
    const navigationHeight = $('.nav-opener-container').outerHeight(true);

    scrollToElement($scrollBase, $accordionItem, navigationHeight, scrollingAnimationTimeMs).done(() => {
      getTracker().handleContentScrolledToTile(scrollingToAccordionItemUuid);
      this.props.onScrollingToContentItemDone();
    });
  }

  shouldComponentUpdate() {
    // This component doesn't render anything, so we never update.
    // This allows us to use this as the root node and not re-render all children
    // whenever we scroll
    return false; 
  }

  render() {
    return this.props.children;
  }

}


export const getTileWrapperElem = (uuid)=>
  $(`#uuid-${uuid}.tile-wrapper`);

export const getSectionWrapperElem = (sectionId)=>
  $(`#section-id-${sectionId}.section-wrapper`);

export const getAccordionItemElem = (uuid)=>
  $(`#accordion-item-${uuid}.accordion-item`);


ScrollManagerForViewer.propTypes = {
  renderAsMobile: PropTypes.bool.isRequired,
  scrollingToSectionId: PropTypes.string,
  scrollingToTileUuid: PropTypes.number,
  scrollingToAccordionItemUuid: PropTypes.string,
  isScrollingToTop: PropTypes.bool,
  scrollingAnimationTimeMs: PropTypes.number,
  onScrollingToContentItemDone:PropTypes.func.isRequired,
  onScrollingToSectionIdDone: PropTypes.func.isRequired,
  onScrolledToTop: PropTypes.func.isRequired
};

ScrollManagerForViewer.defaultProps = {
  scrollingAnimationTimeMs: 500
};

export default ScrollManagerForViewer;
